import { useContext, useEffect } from "react";
import AuthContext from "../context/auth/AuthContext";
import MenuContext from "../context/menus/MenuContext";
import DashboardAdmin from "../components/DashboardAdmin";
import MenuDiario from "../components/MenuDiario";

function Dashboard() {
  const { usuario } = useContext(AuthContext);
  const { menus, obtenerMenus, limpiarEstadoMenus } = useContext(MenuContext);

  useEffect(() => {
    limpiarEstadoMenus();
    obtenerMenus();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {usuario && usuario.administrador ? (
        <div>
          <DashboardAdmin menus={menus} />
        </div>
      ) : (
        <div>
          <MenuDiario menus={menus} />
        </div>
      )}
    </div>
  );
}

export default Dashboard;
